export const ORG_MEMBERS_LEARN_MORE_HREFS = {
  ORG_MEMBERS:
    "https://support.exlyapp.com/support/solutions/articles/84000352066-add-manage-staff-on-exly-how-to-use-this-tool-efficiently-",
};
